/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserFollowPlayerList = {
    type: 'array',
    contains: {
        type: 'UserFollowPlayer',
    },
} as const;
